var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8752 11.2498C20.9106 11.2498 21.75 10.4104 21.75 9.37496C21.75 8.33952 20.9105 7.50012 19.8751 7.50012C18.8395 7.50012 18 8.33959 18 9.37512V11.2498H19.8752ZM14.625 11.2498C15.6605 11.2498 16.5 10.4103 16.5 9.3748V4.12512C16.5 3.08959 15.6605 2.25012 14.625 2.25012C13.5895 2.25012 12.75 3.08959 12.75 4.12512V9.3748C12.75 10.4103 13.5895 11.2498 14.625 11.2498Z",
    fill: "#2EB67D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12484 12.7502C3.08939 12.7502 2.25 13.5896 2.25 14.625C2.25 15.6605 3.08947 16.4999 4.12492 16.4999C5.16045 16.4999 6 15.6604 6 14.6249V12.7502H4.12484ZM9.375 12.7502C8.33947 12.7502 7.5 13.5897 7.5 14.6252V19.8749C7.5 20.9104 8.33947 21.7499 9.375 21.7499C10.4105 21.7499 11.25 20.9104 11.25 19.8749V14.6252C11.25 13.5897 10.4105 12.7502 9.375 12.7502Z",
    fill: "#E01E5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7503 19.8752C12.7503 20.9106 13.5897 21.75 14.6252 21.75C15.6606 21.75 16.5 20.9105 16.5 19.8751C16.5 18.8395 15.6605 18 14.625 18L12.7503 18L12.7503 19.8752ZM12.7503 14.625C12.7503 15.6605 13.5898 16.5 14.6253 16.5L19.875 16.5C20.9105 16.5 21.75 15.6605 21.75 14.625C21.75 13.5895 20.9105 12.75 19.875 12.75L14.6253 12.75C13.5898 12.75 12.7503 13.5895 12.7503 14.625Z",
    fill: "#ECB22E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2497 4.12484C11.2497 3.08939 10.4103 2.25 9.37484 2.25C8.3394 2.25 7.5 3.08947 7.5 4.12492C7.5 5.16045 8.33947 6 9.375 6L11.2497 6L11.2497 4.12484ZM11.2497 9.375C11.2497 8.33947 10.4102 7.5 9.37468 7.5L4.125 7.5C3.08947 7.5 2.25 8.33947 2.25 9.375C2.25 10.4105 3.08947 11.25 4.125 11.25L9.37468 11.25C10.4102 11.25 11.2497 10.4105 11.2497 9.375Z",
    fill: "#36C5F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.4868bea8f243945051cdcd7b6312d235.svg";
export { ForwardRef as ReactComponent };